// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import withStyles from '@tcp/core/src/components/common/hoc/withStyles';
import useHasMounted from '@tcp/core/src/hooks/useHasMounted';
import InfluencerBadge from '@tcp/core/src/components/features/browse/BundleProduct/atoms/InfluencerBadge';
import ColorSwatches from '@tcp/core/src/components/features/browse/BundleProduct/atoms/ColorSwatches';
import Price from '@tcp/core/src/components/features/browse/BundleProduct/atoms/Price';
import RatingAndReviews from '@tcp/core/src/components/features/browse/BundleProduct/atoms/RatingsAndReviews';
import Promotions from '@tcp/core/src/components/features/browse/BundleProduct/atoms/Promotions';
import ImageComponent from '@tcp/core/src/components/features/browse/BundleProduct/atoms/Image';
import Image from '@tcp/core/src/components/common/atoms/Image';
import Anchor from '@tcp/core/src/components/common/atoms/Anchor';
import InfluencerBadgeHandle from '@tcp/core/src/components/common/atoms/InfluencerBadgeHandle/view/InfluencerBadgeHandle';
import AddedtoBagDynamicStore from '@tcp/core/src/components/features/CnC/AddedToBag/container/AddedToBagDynamicStore.js';
import {
  getAPIConfig,
  getIconPath,
  getVideoUrl,
  getDynamicBadgePackQty,
} from '@tcp/core/src/utils/utils';
import { getImageAssetConfig } from '@tcp/core/src/components/features/browse/PlpTile/views/plpTileHelpers/plpTileCommonHelpers.js';
import { hideProductOriginalPrice } from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/views/ProductGridItem.util';
import {
  getProductListToPath,
  getImagesToDisplay,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/utils/productsCommonUtils';
import {
  IMG_DATA_PLP,
  VID_DATA_SLP,
} from '@tcp/core/src/components/features/browse/ProductListing/molecules/ProductList/config';
import {
  GLOBAL_COMMON_BROWSE_LABELS,
  globalCommonBrowseLabels,
} from '@tcp/core/src/utils/labels/globalCommonBrowseLabels.labels';
import { getLabelFromCopyOrFromTranslation } from '@tcp/core/src/utils/labels/labelUtilty';
import ProductBadge from '../../../atoms/ProductBadge/views/ProductBadge.view';
import styles, {
  InfluencerPicksWrapper,
  ImageContainer,
  PriceSection,
  ATBIcon,
  Title,
  ItemsInBagWrapper,
} from '../styles/BundleProductItem.style';
import OutOfStockWaterMarkView from '../../../../ProductDetail/molecules/OutOfStockWaterMark/views/OutOfStockWaterMark.view';
import SafeComponent from '../../../../../../common/hoc/withErrorBoundary/errorBoundary';

const renderInfluencerPicks = ({ influencerPicks, isInfluencerPicksEnabled, hasMounted }) => {
  return (
    <InfluencerPicksWrapper isInfluencerPicksEnabled={isInfluencerPicksEnabled}>
      {hasMounted && isInfluencerPicksEnabled && influencerPicks ? (
        <InfluencerBadge text={influencerPicks} />
      ) : null}
    </InfluencerPicksWrapper>
  );
};

const renderColorSwatches = ({
  productId,
  TCPColor,
  TCPColorSwatches,
  handleClick,
  isNewSwatchUrlEnabled,
  swatchImage,
  assetHost,
  assetPath,
  auxDescription,
  relatedSwatches,
  keepAlive,
}) => {
  return !keepAlive ? (
    <ColorSwatches
      className="color-swatches-wrapper"
      productPartNo={productId}
      TCPSwatches={TCPColorSwatches}
      handleClick={handleClick}
      assetHost={assetHost}
      assetPath={assetPath}
      swatchImg={swatchImage}
      tcpColor={TCPColor}
      auxDescription={auxDescription}
      relatedSwatches={relatedSwatches}
      isNewSwatchUrlEnabled={isNewSwatchUrlEnabled}
    />
  ) : (
    <ColorSwatches className="color-swatches-wrapper empty-swatches" />
  );
};

const renderRatingsAndReviews = ({ ratings, reviewsCount }) => {
  return <RatingAndReviews ratings={ratings} reviewsCount={reviewsCount} />;
};

const renderPrice = ({
  currencySymbol,
  currencyAttributes,
  listPrice,
  offerPrice,
  merchantTag,
  isHideOriginalPrice,
  keepAlive,
}) => {
  return (
    <Price
      minListPrice={listPrice}
      minOfferPrice={offerPrice}
      merchantTag={merchantTag}
      isHideOriginalPrice={isHideOriginalPrice}
      currencyAttributes={currencyAttributes}
      currencySymbol={currencySymbol}
      keepAlive={keepAlive}
    />
  );
};

const renderATBIcon = ({ name, handleClick, productId }) => {
  return (
    <ATBIcon
      onClick={async () => {
        await AddedtoBagDynamicStore();
        handleClick(productId);
      }}
      aria-label={`Add to bag ${name}`}
    >
      <Image
        className="atb-icon-image"
        src={getIconPath('add-to-bag-icon-blue')}
        aria-hidden={true}
        alt="Add to bag Icon"
      />
    </ATBIcon>
  );
};

const renderPriceSection = ({
  currencySymbol,
  currencyAttributes,
  listPrice,
  offerPrice,
  merchantTag,
  isHideOriginalPrice,
  name,
  handleClick,
  productId,
  keepAlive,
}) => {
  return (
    <PriceSection>
      {renderPrice({
        currencySymbol,
        currencyAttributes,
        listPrice,
        offerPrice,
        merchantTag,
        isHideOriginalPrice,
        keepAlive,
      })}
      {renderATBIcon({ name, handleClick, productId })}
    </PriceSection>
  );
};

const renderTitle = ({ newPdpToPath, pdpAsPath, name }) => {
  return (
    <Anchor className="title-wrapper" to={newPdpToPath} asPath={pdpAsPath}>
      <Title fontFamily="secondary" fontSize="fs12">
        {name}
      </Title>
    </Anchor>
  );
};

const renderImage = ({
  pdpAsPath,
  newPdpToPath,
  dynamicBadgeOverlayQty,
  imagesToDisplay,
  influencerTags,
  isBundleOutfitInfluencerHandleEnabled,
  name,
  TCPStyleType,
  brand,
  inYourBagProducts,
  productId,
  keepAlive,
  isSplittingExtendedSizesEnabled,
  colorFitsSizesMap,
}) => {
  const outOfStockCaps = getLabelFromCopyOrFromTranslation(
    `${GLOBAL_COMMON_BROWSE_LABELS}.lbl_common_outOfStockCaps`,
    globalCommonBrowseLabels
  );

  let newFitProdIds = [];
  if (isSplittingExtendedSizesEnabled && colorFitsSizesMap[0]?.hasNewFitAttribute) {
    newFitProdIds = Object.values(colorFitsSizesMap[0]?.newFitProductMap);
  }
  const image = imagesToDisplay?.[0];
  const imageUrl = image?.regularSizeImageUrl;
  const isVideoUrl = imageUrl && getVideoUrl(imageUrl);
  const mainConfig = isVideoUrl ? VID_DATA_SLP.imgConfig : IMG_DATA_PLP.imgConfig;

  return (
    <ImageContainer>
      <ImageComponent
        pdpAsPath={pdpAsPath}
        pdpToPath={newPdpToPath}
        dynamicBadgeOverlayQty={dynamicBadgeOverlayQty}
        mainConfig={mainConfig}
        isVideoUrl={isVideoUrl}
        imageData={{ alt: name, url: imageUrl }}
        TCPStyleType={TCPStyleType}
        badgeConfig={IMG_DATA_PLP.badgeConfig}
        primaryBrand={brand}
      />
      <InfluencerBadgeHandle
        influencerTags={influencerTags}
        image={imageUrl}
        isAbOn={isBundleOutfitInfluencerHandleEnabled}
        productTileImage
      />
      <ItemsInBagWrapper>
        <ProductBadge
          productId={productId}
          inYourBagProducts={inYourBagProducts}
          newFitProdIds={newFitProdIds}
          isSplittingExtendedSizesEnabled={isSplittingExtendedSizesEnabled}
        />
      </ItemsInBagWrapper>
      {keepAlive && (
        <Anchor to={newPdpToPath} asPath={pdpAsPath}>
          <OutOfStockWaterMarkView
            label={outOfStockCaps}
            fontSizes={['fs16', 'fs16', 'fs48']}
            fromBundleOrOutFit={true}
          />
        </Anchor>
      )}
    </ImageContainer>
  );
};

const getPdpAsPath = ({ pdpUrl, seoToken, currentPdpUrl, currentPdpSeoUrl }) => {
  const finalPdpUrl = currentPdpUrl || pdpUrl;
  const pdpSeoUrl = currentPdpSeoUrl || seoToken;
  return seoToken ? `/p/${pdpSeoUrl}` : finalPdpUrl;
};

const getUpdatedPDPUrl = (pdpToPath) => {
  return pdpToPath && `${pdpToPath}&dataSource=bundle`;
};

const renderPromotions = ({
  promotionsData = {},
  TCPPromotionPrice,
  TCPPromotionID,
  isUpdatedPromotionsDisplayEnabled,
  serverTime,
  isBuyMorePromoEnabled,
  brand,
}) => {
  return promotionsData[TCPPromotionID] ? (
    <Promotions
      promotionsData={promotionsData}
      TCPPromotionPrice={TCPPromotionPrice}
      TCPPromotionID={TCPPromotionID}
      isUpdatedPromotionsDisplayEnabled={isUpdatedPromotionsDisplayEnabled}
      serverTime={serverTime}
      isBuyMorePromoEnabled={isBuyMorePromoEnabled}
      brand={brand}
      className="promotions-container"
    />
  ) : null;
};

const BundleProductItem = ({
  className,
  productItem,
  currencySymbol,
  currencyAttributes,
  primaryBrand,
  alternateBrand,
  isHideOriginalPriceAndMarchantTagEnabled,
  isBundleOutfitInfluencerHandleEnabled,
  isInfluencerPicksEnabled,
  isNewSwatchUrlEnabled,
  onQuickViewOpenClick,
  promotionsData,
  isUpdatedPromotionsDisplayEnabled,
  serverTime,
  isBuyMorePromoEnabled,
  resetSlpLoadingState,
  inYourBagProducts,
  isOutfitPage,
  isKeepAliveEnabled,
  isSplittingExtendedSizesEnabled,
  isDynamicBadgeEnabledAbtest,
}) => {
  const {
    TCPColor,
    TCPColorSwatches,
    colorFitsSizesMap,
    pdpUrl,
    seoToken,
    unbxdRatings,
    unbxdReviewsCount,
    productId,
    auxDescription,
    relatedSwatches,
    listPrice,
    offerPrice,
    name,
    imagesByColor,
  } = productItem || {};

  const hasMounted = useHasMounted();
  let currentColorEntry = colorFitsSizesMap?.[0];
  if (productItem?.colorFitsSizesMap?.length > 1) {
    currentColorEntry = productItem?.colorFitsSizesMap?.find(
      (item) => item.colorProductId === productId
    );
  }
  const influencerPicks = currentColorEntry?.influencerPicks?.[0];
  const influencerTags = currentColorEntry?.influencerTags;
  const swatchImage = currentColorEntry?.color.swatchImage;
  const merchantTag = currentColorEntry?.miscInfo.badge2;

  const isHardMarkDown = currentColorEntry?.hardMarkDown;
  const TCPPromotionID = currentColorEntry?.TCPPromotionID;
  const TCPPromotionPrice = currentColorEntry?.TCPPromotionPrice;
  const isHideOriginalPrice = hideProductOriginalPrice(
    isHardMarkDown,
    isHideOriginalPriceAndMarchantTagEnabled
  );
  const apiConfig = getAPIConfig();
  const { brandId } = apiConfig;
  const brand = primaryBrand || brandId;
  const brandInLowerCase = brand?.toLowerCase();
  const { assetHost, assetPath } = getImageAssetConfig(brandInLowerCase, apiConfig);

  const currentPdpUrl = currentColorEntry?.pdpUrl;
  const currentPdpSeoUrl = currentColorEntry?.pdpSeoUrl;
  let pdpAsPath = getPdpAsPath({ pdpUrl, seoToken, currentPdpUrl, currentPdpSeoUrl });
  pdpAsPath = alternateBrand ? `${pdpAsPath}$brand=${alternateBrand}` : `${pdpAsPath}`;
  const pdpToPath = getProductListToPath(pdpAsPath);
  let newPdpToPath = getUpdatedPDPUrl(pdpToPath);
  newPdpToPath = alternateBrand ? `${newPdpToPath}$brand=${alternateBrand}` : `${newPdpToPath}`;

  const TCPStyleType = currentColorEntry?.miscInfo?.tcpStyleType;
  const TCPStyleQTY = currentColorEntry?.miscInfo?.tcpStyleQty;

  const dynamicBadgeOverlayQty = getDynamicBadgePackQty(
    TCPStyleType,
    TCPStyleQTY,
    isDynamicBadgeEnabledAbtest
  );

  const imagesToDisplay = getImagesToDisplay({
    imagesByColor,
    curentColorEntry: currentColorEntry,
    isFullSet: true,
  });

  const keepAlive = isKeepAliveEnabled && currentColorEntry?.miscInfo?.keepAlive;

  const handleClick = (colorProductId) => {
    if (alternateBrand) {
      resetSlpLoadingState({ alternateBrandName: alternateBrand });
    }

    if (isOutfitPage) {
      onQuickViewOpenClick({
        colorProductId,
        fromPage: 'outfit',
      });
    }

    onQuickViewOpenClick({
      colorProductId,
      fromPage: 'bundle',
    });
  };

  return (
    <div className={`${className} bundle-product-list-item`}>
      {renderInfluencerPicks({ influencerPicks, isInfluencerPicksEnabled, hasMounted })}
      {renderImage({
        pdpAsPath,
        newPdpToPath,
        dynamicBadgeOverlayQty,
        imagesToDisplay,
        influencerTags,
        isBundleOutfitInfluencerHandleEnabled,
        name,
        TCPStyleType,
        brand,
        inYourBagProducts,
        productId,
        keepAlive,
        isSplittingExtendedSizesEnabled,
        colorFitsSizesMap,
      })}
      {renderColorSwatches({
        productId,
        TCPColor,
        TCPColorSwatches,
        handleClick,
        isNewSwatchUrlEnabled,
        swatchImage,
        assetHost,
        assetPath,
        auxDescription,
        relatedSwatches,
        keepAlive,
      })}
      {renderPriceSection({
        currencySymbol,
        currencyAttributes,
        listPrice,
        offerPrice,
        merchantTag,
        isHideOriginalPrice,
        name,
        handleClick,
        productId,
        keepAlive,
      })}
      {renderPromotions({
        promotionsData,
        TCPPromotionPrice,
        TCPPromotionID,
        isUpdatedPromotionsDisplayEnabled,
        serverTime,
        isBuyMorePromoEnabled,
        brand,
      })}
      {renderTitle({ newPdpToPath, pdpAsPath, name })}
      {renderRatingsAndReviews({
        ratings: unbxdRatings,
        reviewsCount: unbxdReviewsCount,
      })}
    </div>
  );
};
const BundleProductItemVanilla = SafeComponent(BundleProductItem);
export default SafeComponent(withStyles(BundleProductItem, styles));
export { BundleProductItemVanilla };
